// Custom Element para Countdown Timer
class CountdownTimerExtended extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    // Obtener datos de los atributos
    const offerEndDate = this.getAttribute('offer-end-date');
    const showCountdown = this.getAttribute('show-countdown') === 'true';
    const isAvailable = this.getAttribute('product-available') === 'true';
    const countdownText = this.getAttribute('countdown-text') || 'Sale ends'; // Default text

    // Renderizar el contenido
    this.render(offerEndDate, showCountdown, isAvailable, countdownText);

    // Iniciar countdown si es necesario
    if (showCountdown && isAvailable && offerEndDate) {
      this.startCountdown(offerEndDate, countdownText);
    }
  }

  render(offerEndDate, showCountdown, isAvailable, countdownText) {
    // Mantener el div contenedor
    let html = '<div class="card-timer-sale">';

    // Debug info
    html += `<!-- DEBUG: offer_end_date = ${offerEndDate} | show_countdown = ${showCountdown} | text = ${countdownText} -->`;

    // Countdown display
    if (showCountdown && isAvailable && offerEndDate) {
      html += `<div class="card__countdown" data-sale-end-date="${offerEndDate}">[${countdownText} in HH:MM:SS]</div>`;
    }

    html += '</div>';

    this.innerHTML = html;
  }

  startCountdown(endDateString, countdownText) {
    const countdownEl = this.querySelector('.card__countdown');
    if (!countdownEl) return;

    const endDate = new Date(endDateString).getTime();

    if (isNaN(endDate)) {
      console.error('❌ Fecha inválida para countdown:', endDateString);
      countdownEl.innerHTML = 'Invalid date';
      return;
    }

    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        clearInterval(this.interval);
        countdownEl.innerHTML = `${countdownText} has ended`;
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let timeDisplay = '';
      if (days > 0) {
        timeDisplay = `${days}d ${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        timeDisplay = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      countdownEl.innerHTML = `[${countdownText} in ${timeDisplay}]`;
    }, 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Registrar el custom element
customElements.define('countdown-timer-extended', CountdownTimerExtended);